/**
 * Blog cover image with reliable fill + CSS background fallback.
 * Defaults to the ammo pile asset when a post has no dedicated cover.
 */

import React from 'react';
import { getAssetUrl } from '../utils/assetUtils';
import { DEFAULT_BLOG_IMAGE, getBlogCoverImage } from '../utils/blogImages';

const BlogCover = ({
  post,
  alt = '',
  className = '',
  imgClassName = '',
  children,
}) => {
  const coverPath = getBlogCoverImage(post);
  const src = getAssetUrl(coverPath || DEFAULT_BLOG_IMAGE);
  const fallbackSrc = getAssetUrl(DEFAULT_BLOG_IMAGE);

  return (
    <div
      className={`relative overflow-hidden bg-theme-gunmetal ${className}`}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 w-full h-full object-cover ${imgClassName}`}
        loading="eager"
        decoding="async"
        onError={(e) => {
          if (e.currentTarget.src !== fallbackSrc) {
            e.currentTarget.src = fallbackSrc;
          }
        }}
      />
      {children}
    </div>
  );
};

export default BlogCover;
